import { useQuery } from '@tanstack/react-query';
import requests from 'service/api';
import SearchSelect from '../search-select';
import { useEffect, useState, useMemo } from 'react';
import { useFormikContext } from 'formik';
export function SelectReferanceCode3({ name, brannd, typee = null }) {
  const { values } = useFormikContext();
  const [selected, setSelected] = useState(null);

  const { data = [], isFetched } = useQuery({
    queryKey: ['/list', 'referance'],
    queryFn: async () => {
      try {
        const { data } = await requests.referance.list();
        return data;
      } catch (error) {
        console.error('API Error:', error);
        return [];
      }
    },
    placeholderData: [],
  });

  const labelCategory = brannd === 'ZaraHome' ? 'LABEL9 KARTI' : 'FİYAT KARTI';

  const isWasgingLabel = Array.isArray(data)
    ? data.filter((item) => item.labelCategory === labelCategory)
    : [];

  const options = useMemo(
    () =>
      isWasgingLabel.map(({ id, code }) => ({
        value: id,
        label: code,
      })),
    [isWasgingLabel]
  );

  // typee 'bedlinen' ise sadece "LABEL9 52X90 DUVET" kalsın, değilse tüm options
  const filteredOptions = useMemo(() => {
    if (typee === 'Bedlinen') {
      return options.filter((o) => o.label === 'LABEL9 52X90 DUVET');
    }
    return options;
  }, [typee, options]);

  useEffect(() => {
    if (!isFetched) return;

    // Formik'teki mevcut değere göre seçimi ayarla
    const formikVal = values?.priceLabel?.[0]?.referanceCode;
    let nextSelected = null;

    if (formikVal != null) {
      nextSelected =
        filteredOptions.find(({ value }) => value === formikVal) ?? null;
    }

    // Eğer formik değeri yoksa ve mevcut selected filteredOptions içinde değilse temizle
    if (
      nextSelected == null &&
      selected &&
      !filteredOptions.some((o) => o.value === selected.value)
    ) {
      nextSelected = null;
    }

    setSelected(nextSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetched, values?.priceLabel]);

  return (
    <SearchSelect
      name={name}
      label="Referans Kodu"
      options={filteredOptions}
      value={selected || null}
      onChange={(e) => setSelected(e)}
    />
  );
}